export const MISSIONNEMENT = "MISSIONNEMENT"

export const MISSIONNEMENT_FACTURATION = "MISSIONNEMENT_FACTURATION"

export const FACTURATION = "FACTURATION"

export const SAISIE_MISSION = "SAISIE_MISSION"
